var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-textarea',{attrs:{"value":_vm.content,"rows":_vm.rows,"outlined":"","hideDetails":"","readonly":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }